var exports = {
  "T": "xcc377c0b--a5355d--map",
  "L": "xcc377c0b--a5355d--map-pin",
};

module.exports = exports;
